import React from 'react'

class GoogleSignupButton extends React.Component {
  render() {
    return (
        <a href="/google_signin?s=pocket&t=signup" className="signup-btn-google">
          <span className="logo"></span>
          <span className="text">{ this.props.text }</span>
        </a>
    )
  }
}

export { GoogleSignupButton }
